import React, { FC } from 'react'
import { CheckboxComponent, LinkComponent, Indent } from 'LibNeo'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import { AgreementCheckboxFieldNames } from 'Pages/ibro'
import { OutLinks } from 'Constants/OutLinks'
import { AgreementForm } from './AgreementForm'

interface ComponentProps {
	form: WrappedFormUtils
	disableAll: boolean
}

export const ElectronicAgreementFormBlock: FC<ComponentProps> = ({ form, disableAll }) => {
	return (
		<>
			<AgreementForm form={form} disableAll={disableAll} />
			<Indent top={16}>
				<CheckboxComponent
					form={form}
					fieldName={AgreementCheckboxFieldNames.ELECTRONIC}
					title={
						<span>
							Подтверждаю, что согласие на обработку и передачу персональных данных Потенциального
							Покупателя получено в электронном виде в соответствии с&nbsp;
							<LinkComponent url={OutLinks.broker.offer} title="Офертой" external inText />
						</span>
					}
				/>
			</Indent>
		</>
	)
}
